<div class="app-header">
  <div class="app-header__logo">
    <qima-button-icon
      (qimaButtonIconClick)="onMenuClick()"
      [qimaButtonIconName]="qimaIcon.iconName.MENU"
      [qimaButtonIconSize]="qimaButton.buttonSize.SMALL"
      [qimaButtonIconStyle]="qimaButtonIcon.buttonIconStyle.TERTIARY_UTILITY"
      [qimaTooltipHasArrow]="true"
      [qimaTooltipIsVisible]="true"
      [qimaTooltipPosition]="tooltipPosition"
      [qimaTooltipText]="tooltipMessage | translate"
      qimaTooltip
      data-cy="main-menu-click"
    >
    </qima-button-icon>
    <img
      (click)="onQimaLogoClick()"
      [src]="qimaLogo"
      alt="qima logo"
      class="qima-logo disable-select"
      data-cy="qima-logo-click"
    />
  </div>
  <div class="app-header__tool-bar">
    <ul>
      <!--      <li class="hide-media-sm">-->
      <!--        <div class="app-header__tool-bar__company">-->
      <!--          <qima-avatar-->
      <!--            *ngIf="managerAvatar"-->
      <!--            [qimaAvatarImage]="managerAvatar"-->
      <!--            [qimaAvatarSize]="qimaAvatar.avatarSize.BASE"-->
      <!--          ></qima-avatar>-->
      <!--          <qima-avatar-fake-->
      <!--            *ngIf="!managerAvatar"-->
      <!--            [qimaAvatarFakeSize]="qimaAvatar.avatarSize.BASE"-->
      <!--          ></qima-avatar-fake>-->
      <!--          <div class="app-header__tool-bar__company__manager">-->
      <!--            <span class="manager-label"> {{ 'APP_HEADER.ACCOUNT.YOUR_ACCT_MGR' | translate }}: </span>-->
      <!--            <span class="manager-name">{{ currentUser?.sic }}</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </li>-->
      <!--      <li class="app-header__tool-bar__divider hide-media-sm">-->
      <!--        <qima-divider [qimaDividerOrientation]="qimaDivider.orientation.VERTICAL"></qima-divider>-->
      <!--      </li>-->
      <li>
        <div class="app-header__tool-bar__buttons">
          <qima-button-icon
            (qimaButtonIconClick)="openInstructions()"
            [qimaButtonIconName]="qimaIcon.iconName.STUDIES"
            [qimaButtonIconSize]="qimaButton.buttonSize.SMALL"
            [qimaButtonIconStyle]="qimaButtonIcon.buttonIconStyle.TERTIARY_UTILITY"
            [qimaTooltipHasArrow]="true"
            [qimaTooltipPosition]="qimaTooltip.position.BOTTOM_RIGHT"
            [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
            [qimaTooltipStyle]="qimaTooltip.style.DARK"
            [qimaTooltipText]="'APP_HEADER.ACCOUNT.USER_MANUAL' | translate"
            qimaTooltip
            data-cy="main-open-instructions"
          >
          </qima-button-icon>
          <!--          <qima-button-icon-->
          <!--            (qimaButtonIconClick)="openUserGuide()"-->
          <!--            *ngIf="isUserGuideVisible"-->
          <!--            [qimaButtonIconName]="qimaIcon.iconName.INFORMATION"-->
          <!--            [qimaButtonIconSize]="qimaButton.buttonSize.SMALL"-->
          <!--            [qimaButtonIconStyle]="qimaButtonIcon.buttonIconStyle.TERTIARY_UTILITY"-->
          <!--            class="qima-mr-s"-->
          <!--          >-->
          <!--          </qima-button-icon>-->
          <qima-button-icon
            #menuTranslateOrigin="cdkOverlayOrigin"
            (qimaButtonIconClick)="openTranslate($event)"
            [qimaButtonIconName]="qimaIcon.iconName.LANGUAGE_WORLD"
            [qimaButtonIconSize]="qimaButton.buttonSize.SMALL"
            [qimaButtonIconStyle]="qimaButtonIcon.buttonIconStyle.TERTIARY_UTILITY"
            [qimaTooltipHasArrow]="true"
            [qimaTooltipPosition]="qimaTooltip.position.BOTTOM_RIGHT"
            [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
            [qimaTooltipStyle]="qimaTooltip.style.DARK"
            [qimaTooltipText]="'APP_HEADER.ACCOUNT.LANGUAGE_SELECTOR_TIP' | translate"
            cdkOverlayOrigin
            qimaTooltip
            data-cy="main-open-translate"
          >
          </qima-button-icon>
          <!--          <qima-button-icon-->
          <!--            #menuTranslateOrigin="cdkOverlayOrigin"-->
          <!--            [qimaButtonIconName]="qimaIcon.iconName.NOTIFICATION"-->
          <!--            [qimaButtonIconSize]="qimaButton.buttonSize.SMALL"-->
          <!--            [qimaButtonIconStyle]="qimaButtonIcon.buttonIconStyle.TERTIARY_UTILITY"-->
          <!--            cdkOverlayOrigin-->
          <!--          >-->
          <!--          </qima-button-icon>-->
        </div>
      </li>
      <!--      <li class="app-header__tool-bar__divider">-->
      <!--        <qima-divider [qimaDividerOrientation]="qimaDivider.orientation.VERTICAL"></qima-divider>-->
      <!--      </li>-->
      <li>
        <div
          #menuProfileOrigin="cdkOverlayOrigin"
          (click)="openProfile($event)"
          [class.app-header__tool-bar__account--focus]="isProfileMenuVisible"
          [qimaTooltipHasArrow]="true"
          [qimaTooltipPosition]="qimaTooltip.position.BOTTOM_RIGHT"
          [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
          [qimaTooltipStyle]="qimaTooltip.style.DARK"
          [qimaTooltipText]="'APP_HEADER.ACCOUNT.PROFILE_TIP' | translate"
          cdkOverlayOrigin
          class="app-header__tool-bar__account"
          qimaTooltip
          data-cy="main-open-profile"
        >
          <qima-icon
            [qimaIconName]="qimaIcon.iconName.USER"
            data-cy="main-icon"
          ></qima-icon>
        </div>
      </li>
    </ul>
  </div>
</div>

<ng-template
  (detach)="onProfileOverlayDetach()"
  (overlayOutsideClick)="onProfileOverlayOutsideClick()"
  [cdkConnectedOverlayBackdropClass]="'header-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOffsetY]="8"
  [cdkConnectedOverlayOpen]="isProfileMenuVisible"
  [cdkConnectedOverlayOrigin]="menuProfileOrigin"
  [cdkConnectedOverlayPanelClass]="'account-menu'"
  [cdkConnectedOverlayWidth]="280"
  cdkConnectedOverlay
>
  <app-account-menu data-cy="main-account-menu"></app-account-menu>
</ng-template>

<ng-template
  (detach)="onTranslateOverlayDetach()"
  (overlayOutsideClick)="onTranslateOverlayOutsideClick()"
  [cdkConnectedOverlayBackdropClass]="'header-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOffsetY]="8"
  [cdkConnectedOverlayOpen]="isTranslateMenuVisible"
  [cdkConnectedOverlayOrigin]="menuTranslateOrigin"
  [cdkConnectedOverlayWidth]="180"
  cdkConnectedOverlay
>
  <app-translate-menu data-cy="main-translate-menu"></app-translate-menu>
</ng-template>
